var map = {
	"./fotos/about leder.png": 130,
	"./fotos/about me.png": 572,
	"./fotos/ng01.jpeg": 420,
	"./fotos/ng02.jpeg": 293,
	"./fotos/ng03.jpeg": 30,
	"./fotos/ng04.jpeg": 623,
	"./logo/Logo_nurleder.png": 556,
	"./logo/account.jpg": 194,
	"./logo/logo.png": 182,
	"./logo/warenkorb.jpg": 942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 589;